import qs from 'qs';
import axios from 'axios';
import { call } from 'redux-saga/effects';

import {
    GET_SOON_MOVIES_ENDPOINT,
    GET_MOVIE_DETAILS_ENDPOINT,
    ADD_MOVIE_TO_FAVORITE_ENDPOINT,
    REMOVE_MOVIE_FROM_FAVORITE_ENDPOINT,
    SEND_MOVIE_REVIEW_ENDPOINT,
    GET_RECENT_MOVIES_ENDPOINT,
    GET_SOON_IN_CINEMA_MOVIES_ENDPOINT,
    GET_MOVIE_TIME_SCHEDULER_ENDPOINT,
    GET_ALL_MOVIES_ENDPOINT,
    GET_RECENT_MOVIES_PAGE_ENDPOINT,
    GET_SOON_IN_CINEMA_FILTERED_MOVIES_ENDPOINT,
    GET_MOVIE_SCHEDULE_ENDPOINT,
    GET_RECENT_MOVIES_SLIDER_ENDPOINT,
    GET_RECOMMENDED_MOVIES_ENDPOINT
} from '../config/apiEndpoints';

import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';
import { string } from 'prop-types';

export function* getSoonMovies(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_SOON_MOVIES_ENDPOINT, header);
}

export function* getRecentMovies(payload) {
    const header = tokenHeader();
    const url = GET_RECENT_MOVIES_ENDPOINT + "&film_status_target_id[]=30&film_status_target_id[]=31&film_status_target_id[]=32&items_per_page=All";
    return yield call(axios.get, url, header);
}


export function* getMovieDetails(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_MOVIE_DETAILS_ENDPOINT + payload + '?_format=api_json', header);
}

export function* addMovieToFavorite(payload) {
    const header = tokenHeader();
    const body = {
        data: {
            type: "favourite_film--favourite_film",
            relationships: {
                film: {
                    data: {
                        type: "film--film",
                        id: payload
                    }
                }
            }
        }
    }
    return yield call(axios.post, ADD_MOVIE_TO_FAVORITE_ENDPOINT, body, header);
}

export function* removeMovieFromFavorite(payload){
    const header = tokenHeader();
    return yield call(axios.delete, REMOVE_MOVIE_FROM_FAVORITE_ENDPOINT + payload, header);
}

export function* sendMovieReview(payload){
    const header = tokenHeader();
    const body = {
        film_id: payload,
        comment: "Lorem ipsum dolor sit amet",
        rating: 3
    }

    return yield call(axios.post, SEND_MOVIE_REVIEW_ENDPOINT, payload, header);
}

export function* getSoonInCinemaMovies(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_SOON_IN_CINEMA_MOVIES_ENDPOINT + payload, qs.stringify(payload), {header});
}

export function* getMovieTimeScheduler(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_MOVIE_TIME_SCHEDULER_ENDPOINT + payload, header);
}

export function* getAllMovies(payload) {
    
    const header = tokenHeader();
    let url = GET_ALL_MOVIES_ENDPOINT;
    if (payload !== undefined){
        if (payload.includes("&sort_by=film_translated_title_value")){
            url += "&items_per_page=25&page=0&sort_order=ASC" + payload;
        } else if (payload.includes("&sort_by=film_rating_imdb_value")){
            url += "&items_per_page=25&page=0&sort_order=DESC" + payload;
        }else {
            url += "&items_per_page=25&page=0&sort_order=DESC&sort_by=film_release_date_value" + payload;
        }
    } else {
        url += "&items_per_page=25&page=0&sort_order=DESC&sort_by=film_release_date_value"
    }

    return yield call(axios.get, url, header);
}

export function* getAllMoviesSeeMore(payload) {
    const header = tokenHeader();  
    let url = GET_ALL_MOVIES_ENDPOINT;
    if (payload.includes("&sort_by=film_translated_title_value")){
        url += `&items_per_page=25&page=${payload}&sort_order=ASC`;
    } else if (payload.includes("&sort_by=film_rating_imdb_value")){
        url += `&items_per_page=25&page=${payload}&sort_order=DESC`;
    } else {
        url += `&items_per_page=25&page=${payload}&sort_order=DESC&sort_by=film_release_date_value`;
    }

    return yield call(axios.get, url, header);
}

export function* getRecentMoviesPage(payload) {
    const header = tokenHeader();
    let url = GET_RECENT_MOVIES_PAGE_ENDPOINT;
    if (payload !== undefined){
        if (payload.includes("&sort_by=film_translated_title_value")){
            url += "items_per_page=25&page=0&sort_order=ASC" + payload;
        } else if (payload.includes("&sort_by=film_rating_imdb_value")){
            url += "items_per_page=25&page=0&sort_order=DESC" + payload;
        }else {
            url += "items_per_page=25&page=0&sort_order=DESC&sort_by=film_release_date_value" + payload;
        }
    } else {
        url += "items_per_page=25&page=0&sort_order=DESC&sort_by=film_release_date_value&film_status_target_id[]=30&film_status_target_id[]=31&film_status_target_id[]=32";
    }
    return yield call(axios.get, url, header);
}

export function* getRecentMoviesSeeMore(payload) {
    const header = tokenHeader();
    let url = GET_RECENT_MOVIES_PAGE_ENDPOINT;
    if (payload.includes("&sort_by=film_translated_title_value")){
        url += `&items_per_page=25&page=${payload}&sort_order=ASC`;
    } else if (payload.includes("&sort_by=film_rating_imdb_value")){
        url += `&items_per_page=25&page=${payload}&sort_order=DESC`;
    } else {
        url += `&items_per_page=25&page=${payload}&sort_order=DESC&sort_by=film_release_date_value&film_status_target_id[]=30&film_status_target_id[]=31&film_status_target_id[]=32`;
    }

    return yield call(axios.get, url, header);
}

export function* getSoonInCinemaFilteredMovies(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_SOON_IN_CINEMA_FILTERED_MOVIES_ENDPOINT + payload, header);
}

export function* getMovieSchedule(payload) {
    const header = tokenHeader();
    const url = GET_MOVIE_SCHEDULE_ENDPOINT + `${payload.film_id}/${payload.date}?_format=api_json&cinema_address_locality=${payload.locality}`
    return yield call(axios.get, url, header);
}

export function* recentMoviesSlider(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_RECENT_MOVIES_SLIDER_ENDPOINT, qs.stringify(payload), {header});
}

export function* getRecommendedMovies(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_RECOMMENDED_MOVIES_ENDPOINT + '/' + payload + '?_format=api_json&items_per_page=4', header)
}



// WEBPACK FOOTER //
// ./src/SHARED/api/movies.api.js